export default __webpack_public_path__ + "static/media/Flag of European Union.f704db98.gif";